// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as ColumnsBDefault } from '../../../assets/icons/default/layout/columns-b.svg?react';
import { ReactComponent as ColumnsBSolid } from '../../../assets/icons/solid/layout/COLUMNS-B.svg?react';
import { createIcons } from '../../Icon';
const ColumnsBIcon = /* @__PURE__ */ createIcons('ColumnsB', {
    default: ColumnsBDefault,
    solid: ColumnsBSolid
});
ColumnsBIcon.supportedTypes = ['default', 'solid'];
ColumnsBIcon.category = 'layout';
export default ColumnsBIcon;
